var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-field"},_vm._l((_vm.tags),function(tag,index){return _c('ABTag',{key:`${index}-${tag.value}`,attrs:{"color":_vm.resolveColor(tag.color, _vm.colorVariables)}},[_vm._v("\n    "+_vm._s(tag.value)+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }